import { Button, Dialog, DialogContent, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useModalStyles } from "@saleor/autobooking/styles/modalStyles";
import { DialogProps } from "@saleor/types";
import React from "react";

export interface ConfirmDialogProps extends DialogProps {
  modalText: string;
  modalTitle: string;
  confirmLabel: string;
  cancelLabel: string;
  handleConfirm: () => void;
  handleCancel: () => void;
  modalTitleTxtClass?: string;
  confirmLabelBtnClass?: string;
  confirmLabelTxtClass?: string;
  cancelLabelBtnClass?: string;
  cancelLabelTxtClass?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = props => {
  const {
    onClose,
    open,
    modalText,
    modalTitle,
    confirmLabel,
    cancelLabel,
    handleConfirm,
    handleCancel,
    modalTitleTxtClass,
    confirmLabelBtnClass,
    confirmLabelTxtClass,
    cancelLabelBtnClass,
    cancelLabelTxtClass
  } = props;

  const classes = useModalStyles(props);

  return (
    <Dialog onClose={onClose} open={open} maxWidth="xs" fullWidth>
      <DialogContent className={classes.modal}>
        <div className={classes.modalHeader}>
          <IconButton
            aria-label="close"
            onClick={() => onClose()}
            className={classes.modalCloseBtn}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <div className={classes.modalCenter}>
          <div className={classes.modalTitleContainer}>
            <p
              className={
                modalTitleTxtClass ||
                `${classes.modalTitleText} ${classes.modalTitleTextMargin}`
              }
            >
              {modalTitle}
            </p>
            <p className={classes.modalTextContent}>
              <div
                dangerouslySetInnerHTML={{
                  __html: modalText
                }}
              ></div>
            </p>
          </div>
        </div>

        <div
          className={`${classes.modalBottom} ${classes.padding0}`}
          style={{ textAlign: "center" }}
        >
          <Button
            id="cancelDialogBtn"
            autoFocus
            onClick={handleCancel}
            color="primary"
            style={{ marginRight: 10 }}
            className={cancelLabelBtnClass || classes.btnCancel}
          >
            <span className={cancelLabelTxtClass || classes.txtWhite}>
              {cancelLabel}
            </span>
          </Button>
          <Button
            id="confirmDialogBtn"
            autoFocus
            onClick={handleConfirm}
            color="primary"
            variant="contained"
            className={confirmLabelBtnClass || classes.btnYes}
          >
            <span className={confirmLabelTxtClass || classes.txtWhite}>
              {confirmLabel}
            </span>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

ConfirmDialog.displayName = "ConfirmDialog";
export default ConfirmDialog;
